<template>
  <div class="mains">
    <div class="campus">
      习题管理
      <span>></span>
      制作习题
      <span>></span>
      大题列表
      <span>></span>
      小题列表
      <span>></span>
      编辑阅读理解题
    </div>
    <div class="student_test">
      <el-card>
        <div class="grid-content">
          <div class="rule">
            <div class="xiaoqu_1">制作习题</div>
            <div class="xiaoqu_2">
            </div>
          </div>
          <p class="tishi">
            <i>
              <img src="@/assets/img/education-manage/campus/shenzhong.png" alt />
            </i> 功能前方标注红色星号的属于必填内容，未标星号的是选填内容可进行自由填写，不同功能的备注事宜写在功能后方
          </p>
          <div class="form_1">
            <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
              <el-form-item label="习题范例" v-show="show">
                <div class="xtfl1">
                  <h3 style="marginTop:10px;">阅读原文:</h3>
                  <h3>
                    My school is very big. It has sixteen classrooms. There are three hundred students in it. I'm in Class 2, Grade 4. There are two doors and six windows in my classroom. On the teacher's desk, there is
                    a computer.
                  </h3>
                  <p style="marginLeft:25px; fontWeight:700;">1.The school has________classrooms.</p>
                  <div class="example">
                    <span>A: one B: two C: three</span>

                  </div>
                  <el-button type="primary" @click="show = false">收起</el-button>
                </div>
              </el-form-item>
              <el-form-item label="阅读原文" prop="content">
                <el-input type="textarea" v-model="form.content" class="xtfl" rows="9" placeholder="请在此处输入阅读理解题型的题干，阅读原文可支持文字及图片格式"></el-input>
                <img style="display:inlineBlack; width:100px; height:100px; margin:0 0 0 20px;" v-if="imageUrl" :src="imageUrl" alt="">
                <div style="position:absolute; right:330px; top:0;">
                  <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request="handleAvatarSuccessImg">
                    <el-button v-if="!imageUrl" type="primary" class="mt-1">
                      + 导入图片
                    </el-button>
                  </el-upload>
                  <el-button v-if="imageUrl" type="primary" @click="removeImage" style="position:absolute; left:-110px; top:10px;">
                    - 删除图片
                  </el-button>
                </div>

                <div class="expansion">
                  <el-button @click="show=true" v-show="!show" type="primary">展开</el-button>
                </div>

              </el-form-item>
              <el-form-item label="小题数量">
                <el-select v-model="littleNumber">
                  <el-option v-for="item in littleQuestion" :key="item.id" :label="item.value" :value="item.value"></el-option>
                </el-select>
                <el-button type="primary" style="marginLeft:60px;" @click="prex()" v-show="updateLitleQuestion1">上一题</el-button>
                <el-button type="primary" style="marginLeft:60px;" @click="prex1()" v-show="looknextQuestion">上一题</el-button>
                <el-button type="primary" style="marginLeft:60px;" @click="updatearticle()" v-show="nextQuestion">下一题</el-button>
                <el-button type="primary" style="marginLeft:60px;" @click="updateTopic()" v-show="updateLitleQuestion">下一题</el-button>
                <el-button type="primary" style="marginLeft:60px;" @click="next()" v-show="looknextQuestion">下一题</el-button>
                <el-button type="primary" style="marginLeft:60px;" @click="next1()" v-show="looknextQuestion1">下一题</el-button>
                <span style="display:inlineBlack; marginLeft:40px;fontWeight:700;fontSize:14px;">第{{index}}小题</span>
              </el-form-item>
              <el-form-item label="小题题目" prop="title">
                <el-input type="textarea" v-model="form.title" class="xtfl" rows="9"></el-input>
              </el-form-item>
              <el-form-item label="小题选项" prop="chooseListAnswer">
                <el-radio-group v-model="form.chooseListAnswer" @change="selector()">
                  <div class="options" v-for="(item, index) in chooseList" :key="index">
                    <div class="options_left">
                      <p>{{item.label}}</p>
                      <el-radio v-model="item.radio1" :label="item.label" class="options_left_radio">设为正确答案</el-radio>
                    </div>
                    <div class="options_right">
                      <el-input type="textarea" v-model="item.content" rows="9" cols="85">111</el-input>
                      <div class="right_button">
                        <el-upload style="marginRight:20px;" action="#" :show-file-list="false" :http-request="handleAvatarSuccess1">
                          <el-button v-if="!item.audio" type="primary" class="mt-12" @click="selector1(item)">
                            + 导入音频
                          </el-button>
                        </el-upload>
                        <el-button v-if="item.audio" type="primary" style="width:110px; height:40px; margin:11px 20px 20px 0;" @click="removeitemaudio(item)">
                          删除音频
                        </el-button>
                        <audio v-if="item.audio" controls controlsList="nodownload" style="position:absolute; top:80px; left:10px; width:140px; height:40px;" :src="item.audio"></audio>
                        <div style="position:absolute; top:80px; left:165px; width:100px; height:100px;" v-if="item.img">
                          <img :src="item.img" alt="" style="width:100%;">
                        </div>
                        <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request="handleAvatarSuccessImg1">
                          <el-button v-if="!item.img" type="primary" class="mt-1" @click="selector1(item)">
                            + 导入图片
                          </el-button>
                        </el-upload>
                        <el-button v-if="item.img" type="primary" style="width:110px; height:40px; margin:11px 0 0 0;" @click="removeitemimg(item)">
                          删除图片
                        </el-button>
                      </div>
                    </div>
                  </div>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary" size="mini" @click="addChooseList()">+添加选项</el-button>
                <el-button type="primary" size="mini" @click="removeChooseList()">-删减选项</el-button>
              </el-form-item>
              <el-form-item label="答案解析" prop="answerparse">
                <el-input type="textarea" v-model="form.answerparse" class="xtfl" rows="5" placeholder="您可自由输入该习题的答案解析"></el-input>
              </el-form-item>
              <el-form-item label="难易程度" prop="radios">
                <el-radio-group v-model="form.radios">
                  <el-radio :label="1">易</el-radio>
                  <el-radio :label="2">中</el-radio>
                  <el-radio :label="3">难</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="知识点" prop="knowledge">
                <el-input type="textarea" v-model="form.points" class="xtfl" rows="5" placeholder="您可自行输入该题目所涉及到的知识点，可自由选择是否输入"></el-input>
              </el-form-item>
              <el-form-item class="tijiao">
                <el-button type="primary" @click="updateback()" v-if="edit" v-show="!nextQuestion" style="width:240px; height:46px; marginLeft:30px;">继续制题</el-button>
                <el-button type="primary" v-if="edit" @click="updatearticle()" v-show="nextQuestion" style="width:240px; height:46px; marginLeft:30px;">继续制题</el-button>
                <el-button type="primary" @click="editarticle()" v-else style="width:240px; height:46px; marginLeft:30px;">保存编辑</el-button>
                <el-button style="width:240px; height:46px; marginLeft:30px;" v-show="edit" @click="comeBack=true">保存并返回</el-button>
                <div style="marginLeft:270px;" v-show="comeBack">
                  <el-button style="width:240px; height:46px; marginLeft:30px;" @click="comeBackBig(1)">返回大题列表</el-button>
                  <div>
                    <el-button style="width:240px; height:46px; marginLeft:30px;" @click="comeBacksmall(2)">返回小题列表</el-button>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>

        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
const axios = require('axios');
export default {
  data() {
    return {
      form: {
        title: '',
        chooseListAnswer: '',
        answerparse: '',
        content: '',
        points: '',
        radios: '',
      },
      looknextQuestion1: false,
      index: 1,
      FormRules: {
        content: [{ required: true, message: '请您填写必填信息', trigger: 'blur' }],
        title: [{ required: true, message: '请您填写必填信息', trigger: 'blur' }],
        chooseListAnswer: [{ required: true, message: '请您填写必填信息', trigger: 'blur' }],
        rightAnswers: [{ required: true, message: '请您填写必填信息', trigger: 'blur' }],
      },
      nextQuestion: true,
      littleNumber: 4,
      chooseaudioid: '',
      radio1: '',
      show: true,
      audiosrc: '',
      imageUrl: '',
      optionsId:'',
      littleQuestion: [
        {
          value: 1,
          id: 1,
        },
        {
          value: 2,
          id: 2,
        },
        {
          value: 3,
          id: 3,
        },
        {
          value: 4,
          id: 4,
        },
        {
          value: 5,
          id: 5,
        },
        {
          value: 6,
          id: 6,
        },
        {
          value: 7,
          id: 7,
        },
      ],
      chooseList: [],
      chooseList1: [
        {
          label: 'A',
          questionOptions: 1,
          radio1: '',
          audio: '',
          img: '',
          id: '',
          content: '',
          right: 0,
        },
        {
          label: 'B',
          questionOptions: 2,
          radio1: '',
          audio: '',
          img: '',
          id: '',
          content: '',
          right: 0,
        },
        {
          label: 'C',
          questionOptions: 3,
          radio1: '',
          audio: '',
          img: '',
          id: '',
          content: '',
          right: 0,
        },
        {
          label: 'D',
          questionOptions: 4,
          radio1: '',
          audio: '',
          img: '',
          id: '',
          content: '',
          right: 0,
        },
        {
          label: 'E',
          questionOptions: 5,
          radio1: '',
          audio: '',
          img: '',
          id: '',
          content: '',
          right: 0,
        },
      ],
      indexs: 4,
      looknextQuestion: false,
      updateLitleQuestion: false,
      updateLitleQuestion1: false,
      now: 0,
      smallquestionId: '',
      optionId: '',
      articalId: '',
      smallquestionlist: [],
      edit: true,
      comeBack: false,
      accountForm: {
        photo: {
          icon: require('@/assets/img/xitifanli.png'),
        },
      },
    };
  },
  created() {
    this.verdict();
    console.log(this.$route.query.questionId);
  },

  methods: {
    removeImage() {
      this.imageUrl = '';
    },
    verdict() {
      console.log(this.$route.query.questionId);
      if (this.$route.query.questionId === undefined) {
        console.log(111);
        this.addnumber();
        this.looknextQuestion = false;
      } else {
        this.findchoice();
        this.edit = false;
        this.looknextQuestion = true;
        this.nextQuestion = false;
        this.updateLitleQuestion = false;
      }
    },
    //选项
    addnumber() {
      for (let i = 0; i < this.indexs; i++) {
        this.chooseList.push(this.chooseList1[i]);
        console.log(this.form.chooseList);
      }
    },
    //增加选项
    addChooseList() {
      if (this.indexs >= this.chooseList1.length) {
        this.indexs = this.chooseList1.length;
        return this.$message.warning('选项数量达到上限！');
      } else {
        this.chooseList1[this.indexs].radio1 = '';
        this.chooseList1[this.indexs].audio1 = '';
        this.chooseList1[this.indexs].img = '';
        this.chooseList1[this.indexs].id = '';
        this.chooseList1[this.indexs].content = '';
        this.chooseList1[this.indexs].right = 0;
        this.chooseList.push(this.chooseList1[this.indexs]);
        this.indexs++;
      }
    },
    //删减选项
    removeChooseList() {
      this.indexs--;
      this.optionsId = this.chooseList[this.chooseList.length-1].id;
      this.chooseList.splice(this.indexs);
      if(this.edit == false) {
        this.editRemoveChoose();
      }
      console.log(this.chooseList,this.chooseList.length);
    },
     //编辑时删除选项的接口
    editRemoveChoose(){
      console.log(this.optionsId,"两个数",this.$route.query.id,);
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exercise/option/'+this.$route.query.id+'/'+this.optionsId+'/del',
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result, 'awawa');
        })
        .catch((err) => {
          this.$message.error( err);
        });
    },
    //删除选项音频
    removeitemaudio(item) {
      item.audio = '';
    },
    //删除选项图片
    removeitemimg(item) {
      item.img = '';
    },
    //上传图片
    handleAvatarSuccessImg(data) {
      console.log(data.file);
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.imageUrl = result.data.data;
            this.$message.success('上传成功!');
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },
    beforeAvatarUploadImg(file) {
      // const isJPG = file.type === 'image/jpeg';
      // const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isPNG) {
      //   this.$message.error('上传图片只能是 JPG或者PNG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return  isLt2M;
    },
    selector1(item) {
      console.log(item, 'aaaa');
      if (item.label === 'A') {
        this.chooseaudioid = 1;
        console.log(this.chooseaudioid, 'aaa');
      }
      if (item.label === 'B') {
        this.chooseaudioid = 2;
        console.log(this.chooseaudioid, 'aaa');
      }
      if (item.label === 'C') {
        this.chooseaudioid = 3;
        console.log(this.chooseaudioid, 'aaa');
      }
      if (item.label === 'D') {
        this.chooseaudioid = 4;
        console.log(this.chooseaudioid, 'aaa');
      }
    },
    // 上传选项音频
    handleAvatarSuccess1(data) {
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('audio', data.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadAudio',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          this.chooseList[this.chooseaudioid - 1].audio = result.data.data;
          console.log(this.chooseList[this.chooseaudioid - 1].audio, 'aaaa');
          console.log(this.chooseList, 'aaaaq2qw');
          this.$message.success('上传成功！');
        })
        .catch((err) => {
          this.$message.error('上传音频错误：' + err);
        });
    },
    //上传选项图片
    handleAvatarSuccessImg1(data) {
      console.log(data.file);
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.chooseList[this.chooseaudioid - 1].img = result.data.data;
            console.log(this.chooseList[this.chooseaudioid - 1].img, 'aaaa');
            console.log(this.chooseList);
            this.$message.success('上传成功！');
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },
    //上一题
    prex() {
      if (this.now == 0) {
        this.now = 0;
        this.index--;

        if (this.index < 1) {
          this.index = 1;
        }
        this.findchoice1();
      } else {
        this.updateLitleQuestion = false;
        this.looknextQuestion1 = true;
        this.now -= 1;
        this.index--;
        this.findchoice1();
      }
    },
    prex1() {
      if (this.now === 0) {
        this.now = 0;
        this.index--;

        if (this.index < 1) {
          this.index = 1;
        }
        this.findchoice();
      } else {
        this.now -= 1;
        this.index--;
        this.findchoice();
      }
    },
    //编辑下一题
    next() {
      if (this.now < this.smallquestionlist.length - 1) {
        this.findchoice();
        this.editquestion();
      }
      this.now += 1;
      if (this.now == this.smallquestionlist.length) {
        this.$message.error('已经是最后一题啦!');
        console.log(this.smallquestionlist.length);
        this.now = this.smallquestionlist.length - 1;
      }
    },
    //新建下一题
    next1() {
      if (this.now < this.smallquestionlist.length - 1) {
        this.findchoice1();
        this.editquestion1();
      }
      this.now += 1;
      this.index++;
      if (this.index >= this.littleNumber) {
        this.index = this.littleNumber;
      }
      if (this.now == this.smallquestionlist.length) {
        this.updateLitleQuestion = true;
        this.looknextQuestion1 = false;
        this.imageUrl = '';
        this.form.radios = '';
        this.chooseList[0].content = '';
        this.chooseList[1].content = '';
        this.chooseList[2].content = '';
        this.chooseList[3].content = '';
        this.form.title = '';
        this.form.answerparse = '';
        this.form.points = '';
        console.log(this.smallquestionlist.length);
        this.now = this.smallquestionlist.length - 1;
      }
    },
    //返回大题列表
    comeBackBig(big) {
      this.updateback(big);
    },
    comeBacksmall(big) {
      this.updateback(big);
    },
    selector() {
      console.log(this.form.chooseListAnswer);
      for (let i = 0; i < this.chooseList.length; i++) {
        if (this.form.chooseListAnswer === this.chooseList[i].label) {
          this.chooseList[i].right = 1;
          console.log(i);
          for (let j = 0; j < this.chooseList.length; j++) {
            if (i === j) {
              console.log(j);
            } else {
              console.log(j, '12333');
              this.chooseList[j].right = 0;
            }
          }
        }
      }
    },
    //查询题目
    findchoice() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exercise/' + this.$route.query.questionId + '/essay/read/comprehension/question',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          this.indexs = res.data.data.smallQuestionResults.length;
          this.form.content = res.data.data.text;
          this.imageUrl = res.data.data.img;
          this.smallquestionlist = res.data.data.smallQuestionResults;
          this.chooseList = this.smallquestionlist[this.now].options;
          this.littleNumber = this.smallquestionlist.length;
          this.smallquestionId = this.smallquestionlist[this.now].id;
          this.form.title = this.smallquestionlist[this.now].text;
          this.form.answerparse = this.smallquestionlist[this.now].parse;
          this.form.points = this.smallquestionlist[this.now].points;
          this.form.radios = this.smallquestionlist[this.now].level;
          for (let i = 0; i < this.chooseList.length; i++) {
            if (this.chooseList[i].right === 1) {
              this.form.chooseListAnswer = this.chooseList[i].label;
            }
          }
        }
      });
    },
    findchoice1() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exercise/' + this.articalId + '/essay/read/comprehension/question',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          this.form.content = res.data.data.text;
          this.imageUrl = res.data.data.img;
          this.smallquestionlist = res.data.data.smallQuestionResults;
          this.chooseList = this.smallquestionlist[this.now].options;
          //  this.littleNumber = this.smallquestionlist.length;
          this.smallquestionId = this.smallquestionlist[this.now].id;
          this.form.title = this.smallquestionlist[this.now].text;
          this.form.answerparse = this.smallquestionlist[this.now].parse;
          this.form.points = this.smallquestionlist[this.now].points;
          this.form.radios = this.smallquestionlist[this.now].level;
          for (let i = 0; i < this.chooseList.length; i++) {
            if (this.chooseList[i].right === 1) {
              this.form.chooseListAnswer = this.chooseList[i].label;
            }
          }
        }
      });
    },
    //提交短文
    updatearticle() {
      if(this.form.content.length>3070){
        return this.$message.warning("文章内容超过规定长度！")
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise/make/essay/read/comprehension/text',
        method: 'POST',
        data: {
          attached: {
            bookId: Number(this.$route.query.bookid),
            section: this.$route.query.littleNode,
          },
          img: this.imageUrl,
          level: this.form.radios,
          pack: {
            number: this.$route.query.number,
            questionPackId: this.$route.query.id,
            score: 0,
          },
          score: 0,
          text: this.form.content,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          this.articalId = res.data.data.id;
          console.log(this.articalId, 'sass');
          this.updateTopic();
          this.nextQuestion = false;
          this.updateLitleQuestion = true;
          this.updateLitleQuestion1 = true;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //提交问题
    updateTopic(big) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise/make/essay/read/comprehension/question',
        method: 'POST',
        data: {
          attached: {
            bookId: Number(this.$route.query.bookid),
            section: this.$route.query.littleNode,
          },
          img: this.imageUrl,
          level: this.form.radios,
          options: this.chooseList,
          questionId: this.articalId,
          text: this.form.title,
          parse: this.form.answerparse,
          points: this.form.points,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          console.log(res);
          if (res.data.code === 0) {
            this.$message.success('提交成功！');
            console.log(this.chooseList, 1);
            if (big === 1) {
              this.$router.go(-2);
            } else if (big === 2) {
              this.$router.go(-1);
            }
            this.form.radios = '';
            for (let i = 0; i < this.chooseList1.length; i++) {
              this.chooseList1[i].radio1 = '';
              this.chooseList1[i].audio1 = '';
              this.chooseList1[i].img = '';
              this.chooseList1[i].right = 0;
              this.chooseList1[i].content = '';
            }
            this.chooseList = [];
            this.indexs = 4;
            this.addnumber();
            this.form.title = '';
            this.form.chooseListAnswer = '';
            this.form.answerparse = '';
            this.form.points = '';
            this.index++;
            this.now++;
            console.log(this.chooseList, 2);
          } else {
            return this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
         if(big ==1||big==2){
             this.$confirm('必填信息出错，退出信息将被清空，确定退出?', '退出', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            console.log(111);
            if (big === 1) {
              this.$router.go(-2);
            } else if (big === 2) {
              this.$router.go(-1);
            }
          });
          }else {
            this.$message.error('制题失败:'+err)
          }
        });
    },
    //提交
    updateback(big) {
      this.updateTopic(big);
    },
    //编辑短文
    editarticle() {
      if(this.form.content.length>3070){
        return this.$message.warning("文章内容超过规定长度！")
      }
      console.log(this.$route.query.questionId);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise/' + this.$route.query.id + '/' + this.$route.query.questionId + '/essay/read/comprehension/text/upd',
        method: 'POST',
        data: {
          img: this.imageUrl,
          level: this.form.radios,
          score: 0,
          text: this.form.content,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          this.editquestion();
        }else {
          this.$message.warning(res.data.message);
        }
      });
    },
    //编辑小题
    editquestion() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise/' + this.$route.query.id + '/' + this.$route.query.questionId + '/' + this.smallquestionId + '/essay/read/comprehension/question/upd',
        method: 'POST',
        data: {
          img: this.imageUrl,
          level: this.form.radios,
          score: 0,
          points: this.form.points,
          parse: this.form.answerparse,
          text: this.form.title,
          options: this.chooseList,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          this.$message.success('编辑成功！');
          this.index++;
        }else {
          this.$message.warning(res.data.message);
        }
      });
    },
    //新建编辑小题
    editquestion1() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise/' + this.$route.query.id + '/' + this.articalId + '/' + this.smallquestionId + '/essay/read/comprehension/question/upd',
        method: 'POST',
        data: {
          img: this.imageUrl,
          level: this.form.radios,
          score: 0,
          points: this.form.points,
          parse: this.form.answerparse,
          text: this.form.title,
          options: this.chooseList,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          this.$message.success('编辑成功！');
        }
      });
    },
  },
};
</script>
<style lang="less">
.mains {
  box-sizing: border-box;
}
.el-card_body {
  position: relative;
}
.tishi {
  position: absolute;
  width: 100%;
  top: 60px;
  left: 0;
  color: #f87e2e;
  background-color: #feefe5;
}
.tishi i {
  margin-left: 3.4375rem /* 55/16 */;
}
.form_1 {
  margin-top: 70px;
  margin-left: 273px;
}
.xiaoqu_1 {
  font-weight: 700;
}
.xtfl {
  width: 750px /* 750/16 */;
}
.expansion {
  position: absolute;
  top: 10px;
  right: 240px;
}
.xtfl1 {
  position: relative;
  width: 750px /* 750/16 */;
  height: 100% /* 200/16 */;
  border: 1px solid #cccccc;
}
.xtfl1 h3 {
  margin-left: 1.875rem /* 30/16 */;
  margin-top: 10px;
}

.xtfl1 button {
  position: absolute;
  top: 0;
  right: -100px;
}
.example {
  margin-left: 1.875rem /* 30/16 */;
  margin-top: -20px;
}
.example span {
  display: inline-block;
  margin-right: 10px;
}
.example_img {
  margin-left: 1.875rem /* 30/16 */;
  width: 6.25rem /* 100/16 */;
  height: 6.25rem /* 100/16 */;
}
.options {
  display: flex;
  width: 750px /* 750/16 */;
  height: 12.5rem /* 200/16 */;
  border: 1px solid #cccccc;
  margin-bottom: 20px;
}
.options_left {
  width: 130px;
  height: 100%;
  background-color: #cccccc;
  color: white;
  text-align: center;
}
.options_left p {
  font-size: 16px;
  margin-top: 70px;
}
.options_left_radio {
  color: #fff;
}
.options_right {
  position: relative;
  .right_button {
    position: absolute;
    display: flex;
    right: -260px;
    top: 0;
  }
}
.addLable {
  width: 12.5rem /* 200/16 */;
  height: 2.25rem /* 36/16 */;
}
.btn_addlable {
  width: 6rem /* 96/16 */;
  height: 2.125rem /* 34/16 */;
  margin-left: 1.5625rem /* 25/16 */;
}
.el-textarea__inner {
  resize: none;
}
.score {
  display: flex;
}
.score > :nth-child(2) {
  margin: 0 110px 0 140px;
}
.grade {
  width: 6.25rem /* 100/16 */;
}
.tishi {
  width: 100%;
  top: 60px;
  left: 0;
  color: #f87e2e;
  background-color: #feefe5;
}
.tishi i {
  margin-left: 3.4375rem /* 55/16 */;
}
.look_picture {
  width: 750px;
  height: 200px;
  border: 1px solid #cccccc;
}
.replaceaudio {
  position: relative;
  width: 100px /* 65/16 */;
  height: 42px;
  button {
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .picture {
    position: absolute;
    width: 100px;
    height: 42px;
    margin-left: 200px;
    bottom: 40px;
  }
}
.addaudio {
  display: flex;
  width: 730px;
  height: 55px;
  border: 1px solid rgba(204, 204, 204, 1);
  padding: 10px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
}
</style>
